// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsEksClustersIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-eks-clusters_svga)" d="M40 0H0v40h40z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M19.4 16.14v3.32l2.87-3.32h1.45l-3.25 4 3.41 4.23h-1.42l-3.06-3.8v3.79h-1.28v-8.22zm12.6 8.1-4-2.35v-6.06a.5.5 0 0 0-.29-.45L22 12.74V8.28l10 4.9zm.72-11.8-11-5.39a.5.5 0 0 0-.48.02.5.5 0 0 0-.24.42v5.56q.01.3.29.44L27 16.14v6.03q.02.27.24.42l5 2.95a.5.5 0 0 0 .76-.42V12.88q0-.3-.28-.44M20 32.95 9 27.32V13.17l9-4.85v4.44l-4.75 2.64a.5.5 0 0 0-.25.43v8.84q.01.28.26.43l6.5 3.51a.5.5 0 0 0 .48 0l6.25-3.37 3.55 2.33zm6.8-8.7a.5.5 0 0 0-.53-.01L20 27.62l-6-3.24V16.1l4.75-2.63a.5.5 0 0 0 .25-.43V7.49q-.01-.27-.25-.42a.5.5 0 0 0-.5-.01l-10 5.39a.5.5 0 0 0-.25.43V27.6q0 .3.27.44l11.5 5.9a.5.5 0 0 0 .47-.01l11-5.9a.49.49 0 0 0 .04-.84z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="aws-eks-clusters_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsEksClusters",
);
export default AwsEksClustersIcon;
